import { Link } from "react-router-dom";
import { thinkers } from "@/data/nonlinearThinkers";

const ThinkersMarquee = () => {
  const names = thinkers.map((t) => t.name);
  const duplicated = [...names, ...names, ...names, ...names];

  return (
    <section className="py-12 md:py-16 bg-muted/50 overflow-hidden">
      <div className="container mx-auto px-4 max-w-6xl mb-6 text-center">
        <p className="text-sm uppercase tracking-[0.2em] text-coral-text mb-2">They thought differently</p>
      </div>

      {/* Scrolling marquee */}
      <div className="relative" aria-hidden="true">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-muted/50 to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-muted/50 to-transparent z-10" />

        <div className="flex animate-marquee whitespace-nowrap">
          {duplicated.map((name, i) => (
            <span
              key={`${name}-${i}`}
              className="mx-4 md:mx-6 text-lg md:text-2xl font-heading font-bold text-muted-foreground"
            >
              {name}
            </span>
          ))}
        </div>
      </div>

      <div className="text-center mt-6">
        <Link
          to="/nonlinear-thinkers"
          className="inline-flex items-center gap-2 text-sm font-medium text-coral-text hover:text-coral transition-colors"
        >
          Discover famous nonlinear thinkers →
        </Link>
      </div>
    </section>
  );
};

export default ThinkersMarquee;
